import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home/close.png'


const _withScopeId = n => (_pushScopeId("data-v-1fda23ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  key: 0,
  class: "activity"
}
const _hoisted_7 = { class: "activity-box" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_component_detail = _resolveComponent("component-detail")!
  const _component_components_dispatch_table = _resolveComponent("components-dispatch-table")!
  const _component_component_open = _resolveComponent("component-open")!
  const _component_insurance_money = _resolveComponent("insurance-money")!
  const _component_component_pie = _resolveComponent("component-pie")!
  const _component_component_risk_board = _resolveComponent("component-risk-board")!
  const _component_components_team = _resolveComponent("components-team")!
  const _component_components_file = _resolveComponent("components-file")!
  const _component_components_hotline = _resolveComponent("components-hotline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_component_detail),
      (_ctx.isShow)
        ? (_openBlock(), _createBlock(_component_components_dispatch_table, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_component_open),
      (_ctx.isOrangeTheme)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_insurance_money, { style: {"width":"67%","margin-right":"20px","height":"400px"} }),
              _createVNode(_component_component_pie, { style: {"width":"33%","height":"400px"} })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_component_risk_board, { style: {"width":"67%","margin-right":"20px","height":"400px"} }),
              _createVNode(_component_components_team, { style: {"width":"33%","height":"400px"} })
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_component_risk_board, { style: {"width":"67%","margin-right":"20px","height":"400px"} }),
              _createVNode(_component_component_pie, { style: {"width":"33%","height":"400px"} })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_insurance_money, { style: {"width":"67%","margin-right":"20px","height":"400px"} }),
              _createVNode(_component_components_team, { style: {"width":"33%","height":"400px"} })
            ])
          ], 64)),
      _createVNode(_component_components_file)
    ]),
    (_ctx.activityImg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.activityClick && _ctx.activityClick(...args))),
              src: _ctx.activityImg,
              class: "activity-img"
            }, null, 8, _hoisted_8),
            _createElementVNode("img", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activityImg = '')),
              src: _imports_0,
              class: "activity-close"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_components_hotline)
  ], 64))
}